'use client'

import { PageBackButton } from '@/components/ui/page-back-button'

const BackButton = () => {
  return (
    <PageBackButton
      fallbackHref="/ingredients/seasonal"
      className="flex items-center gap-3 text-xl font-semibold text-[#202020]"
    />
  )
}

export default BackButton
